import { useEffect, useMemo, useState } from "react";
import { CloseIcon, SendMoneyIcon } from "../../assets/Icons";
import { BasicDetails } from "./basicDetails";
import { PermanentAddress } from "./permanentAddress";
import { OtherDetails } from "./otherDetails";
import Button from "../../components/ui/Button";
import { USERDETAILS_DATA } from "../../utils";
import { getRemitterDetails, getUserDetails } from "../../services/userDetails";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userDetails } from "../../store";
import Modal from "../../components/ui/Modal";
import Checkbox from "../../components/ui/Checkbox";

export const UserDetailsPage = () => {
  const [name, setName] = useState<string>("");
  const [nationality, setNationality] = useState<string>("Indian");
  const [gender, setGender] = useState<string>("");
  const [permAddressOne, setPermAddressOne] = useState<string>("");
  const [permAddressTwo, setPermAddressTwo] = useState<string>("");
  const [permPin, setPermPin] = useState<string>("");
  const [permCity, setPermCity] = useState<string>("");
  // const [currAddressOne, setCurrAddressOne] = useState<string>("");
  // const [currAddressTwo, setCurrAddressTwo] = useState<string>("");
  // const [currPin, setCurrPin] = useState<string>("");
  // const [currCity, setCurrCity] = useState<string>("");
  const [sourceFunds, setSourceFunds] = useState<string>("");
  const [employentStatus, setEmploymentStatus] = useState<string>("");
  const [industryType, setIndustryType] = useState<string>("");
  // const [currState, setCurrState] = useState<string>("");
  const [permState, setPermState] = useState<string>("");
  const [dob, setDob] = useState<any>();
  // const [isSameAddress, setIsSameAddress] = useState();
  const [isPolitical, setIsPolitical] = useState<boolean>();
  const [errMessage, setErrMessage] = useState<string>();
  const [verifyEnabled, setVerifyEnabled] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const industries = USERDETAILS_DATA.industryType;
  const statusEmployment = USERDETAILS_DATA.employmentStatus;
  const fundSource = USERDETAILS_DATA.fundSource;
  const nationalityList = USERDETAILS_DATA.nationality;
  const stateList = USERDETAILS_DATA.states;
  const genderList = USERDETAILS_DATA.gender;

  const userKey = localStorage.getItem("userKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const [userData, setUserData] = useRecoilState(userDetails);
  const [isModalOpen, setIsModalOpen] = useState<string>("");

  const navigate = useNavigate();

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    getRemitterDetails(currentUser).then((res: any) => {
      const fullname = `${res.data.firstName} ${res.data.middleName} ${res.data.lastName}`;
      setDob(res.data.dob);
      setName(fullname);
      setPermAddressOne(res?.data?.addressLine1);
      setPermAddressTwo(res?.data?.addressLine2);
      setPermPin(res?.data?.pinCode);
      setPermCity(res?.data?.city);
    });
  }, []);

  useMemo(() => {
    setVerifyEnabled(
      Boolean(
        name &&
        nationality &&
        gender &&
        permAddressOne &&
        permAddressTwo &&
        permPin &&
        permCity &&
        // sourceFunds &&
        employentStatus &&
        industryType &&
        permState &&
        dob,
      ),
    );
  }, [
    name,
    nationality,
    gender,
    permAddressOne,
    permAddressTwo,
    permPin,
    permCity,
    sourceFunds,
    employentStatus,
    industryType,
    permState,
    dob,
  ]);

  const handleVerify = () => {
    setIsDisabled(true);
    const body = {
      firstName: name,
      middleName: "",
      lastName: "",
      gender: gender,
      phoneNumber: "",
      nationality: nationality,
      addressLine1: permAddressOne,
      addressLine2: permAddressTwo,
      state: permState,
      city: permCity,
      pinCode: permPin,
      dob: dob,
      isPhoneVerified: true,
      hop_coins: 0,
      isPolitical: false,
      employmentStatus: employentStatus,
      industryType: industryType,
      // sourceOfFunds: sourceFunds,
      userKey: userKey,
      isDocVerified: true,
      // comAddressLine1: currAddressOne,
      // comAddressLine2: currAddressTwo,
      // comState: currState,
      // comCity: currCity,
      // comPinCode: currPin,
      createdOn: "",
      modifiedOn: "",
      isMasterVendor: false,
    };

    getUserDetails(body)
      .then((response) => {
        setErrMessage("");
        setUserData(response?.data);
        navigate("/pick-recipient");
      })
      .catch((err) => {
        setErrMessage(err.response.data.error.type);
      })
      .finally(() => setIsDisabled(false));
  };

  return (
    <div className="w-[1350px] px-6 mr-5">
      <div id="header" className="w-[1350px] h-10 flex justify-between items-center mt-6 mr-5">
        <div id="left" className="flex items-center space-x-3">
          <div>
            <SendMoneyIcon />
          </div>
          <span className="text-[32px] font-bold">Remitter Details</span>
          <span className="mt-3 ml-10 font-semibold">Enter basic details of the remitter</span>
        </div>
        {/* <div id="right" className="cursor-pointer mr-7" onClick={() => setIsModalOpen("cancel")}>
          <CloseIcon fill="black" />
        </div> */}
      </div>
      <BasicDetails
        name={name}
        setName={setName}
        nationality={nationality}
        setNationality={setNationality}
        gender={gender}
        setGender={setGender}
        genderList={genderList}
        nationalityList={nationalityList}
        dob={dob}
        setDob={setDob}
      />
      <PermanentAddress
        userData={userData}
        permAddressOne={permAddressOne}
        setPermAddressOne={setPermAddressOne}
        permAddressTwo={permAddressTwo}
        setPermAddressTwo={setPermAddressTwo}
        permPin={permPin}
        setPermPin={setPermPin}
        permCity={permCity}
        setPermCity={setPermCity}
        permState={permState}
        setPermState={setPermState}
        stateList={stateList}
      />
      <OtherDetails
        sourceFunds={sourceFunds}
        setSourceFunds={setSourceFunds}
        employmentStatus={employentStatus}
        setEmploymentStatus={setEmploymentStatus}
        industryType={industryType}
        setIndustryType={setIndustryType}
        sourceFundList={fundSource}
        industries={industries}
        statusList={statusEmployment}
      />
      <div className="flex items-center justify-start mt-4 space-x-10">
        <div className="flex items-center space-x-4 mt-12">
          <Checkbox
            label={"Are you a politically exposed person?"}
            name={"checkbox"}
            checked={isPolitical}
            inputClassname="flex justify-center w-full"
            labelClassName="text-lg text-gray-500 font-ssp font-semibold"
            // rootclassName="w-full"
            handleChange={() => setIsPolitical(!isPolitical)}
            value={isPolitical}
          />
        </div>
        <div id="last" className="flex items-center mt-10">
          <Button
            bgColor={!verifyEnabled ? "bg-gray-300" : "bg-primary-1050"}
            fontStyle={{
              fontFamily: "font-roboto",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            onClickHandler={handleVerify}
            className={"flex justify-center py-4 mt-6 ml-5 px-14 hover:scale-105 transition-all"}
            disabled={!verifyEnabled}
            isLoading={isDisabled}
          >
            Verify
          </Button>
          {errMessage && <span className="ml-4 text-error">{errMessage}</span>}
        </div>
      </div>
      <Modal
        header="Cancel Transaction"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 rounded-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancel"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="flex flex-col items-center p-10 space-y-6">
          <span className="font-ssp text-[22px]">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex space-x-10">
            <button
              onClick={() => navigate("/remittance")}
              className="px-6 py-2 font-bold text-white rounded bg-primary-650 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="px-6 py-2 font-bold text-white rounded bg-primary font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
